import { createIconComponent } from './helpers';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'

export const CheckIcon = createIconComponent(faCheckCircle);
